import styled from 'styled-components/macro';

export const RenderContainer = styled.div`
    display: flex;
    border-radius: 12px;
    background: #f6f4f4;
    padding: 12px;
    margin: 20px;
    justify-content: center;
`;